import { observer } from 'mobx-react';
import { Page } from '@servicetitan/design-system';
import { SettingsSidebar } from './settings-navigation/settings-sidebar';
import { Route, Switch } from 'react-router-dom';
import { MainSettingsPage } from '../../main-settings/components/main-settings-page/main-settings-page';
import { RevenueAttributionPage } from '../../revenue-attribution/components/revenue-attribution-page';
import { useDependencies } from '@servicetitan/react-ioc';
import {
    MarketingMfe,
    MarketingRouteStore,
    MarketingSection,
    MfeBasenames,
} from '@servicetitan/marketing-global-route';
import { IfOnboarded } from './onboarding/onboarding';
import { FieldsSettingsPage } from '../../fields-settings/components/fields-settings-page';

export const SettingsPage = observer(() => {
    const [{ getPathnameWithStandaloneRoot }] = useDependencies(MarketingRouteStore);

    return (
        <Page sidebar={<SettingsSidebar />} maxWidth="wide" className="page-top-level">
            <Switch>
                <Route
                    path={getPathnameWithStandaloneRoot(
                        MarketingSection.Settings,
                        MfeBasenames[MarketingMfe.MainSettings],
                    )}
                >
                    <MainSettingsPage />
                </Route>
                <IfOnboarded>
                    <Route
                        path={getPathnameWithStandaloneRoot(
                            MarketingSection.Settings,
                            MfeBasenames[MarketingMfe.RevenueAttribution],
                        )}
                    >
                        <RevenueAttributionPage />
                    </Route>
                    <Route
                        path={getPathnameWithStandaloneRoot(
                            MarketingSection.Settings,
                            MfeBasenames[MarketingMfe.FieldsSettings],
                        )}
                    >
                        <FieldsSettingsPage />
                    </Route>
                </IfOnboarded>
            </Switch>
        </Page>
    );
});
